import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getStakeHoldersDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  agencies: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_agency_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_agency_order_sequence",
        formType: "number",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_agency_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_agency_title_zh",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_zh",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Link (EN)",
      fieldValue: "field_agency_link_en",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_en",
      formType: "input",
      label: "Link (EN)",
      placeholder: "Enter Link (EN)",
      validation: { required: "Link (EN) is required" },
    },
    {
      fieldName: "Link (MS)",
      fieldValue: "field_agency_link_ms",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_ms",
      formType: "input",
      label: "Link (MS)",
      placeholder: "Enter Link (MS)",
      // validation: { required: "Link (MS) is required" },
    },
    {
      fieldName: "Link (ZH)",
      fieldValue: "field_agency_link_zh",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_zh",
      formType: "input",
      label: "Link (ZH)",
      placeholder: "Enter Link (ZH)",
      // validation: { required: "Link (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_agency_image",
      className: "col-span-6",
      type: "image",
      name: "field_agency_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Replace Image",
      validation: { required: "Image URL is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  agenciesPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  airlines: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_agency_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_agency_order_sequence",
        formType: "number",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_agency_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_agency_title_zh",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_zh",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Link (EN)",
      fieldValue: "field_agency_link_en",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_en",
      formType: "input",
      label: "Link (EN)",
      placeholder: "Enter Link (EN)",
      validation: { required: "Link (EN) is required" },
    },
    {
      fieldName: "Link (MS)",
      fieldValue: "field_agency_link_ms",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_ms",
      formType: "input",
      label: "Link (MS)",
      placeholder: "Enter Link (MS)",
      // validation: { required: "Link (MS) is required" },
    },
    {
      fieldName: "Link (ZH)",
      fieldValue: "field_agency_link_zh",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_zh",
      formType: "input",
      label: "Link (ZH)",
      placeholder: "Enter Link (ZH)",
      // validation: { required: "Link (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_agency_image",
      className: "col-span-6",
      type: "image",
      name: "field_agency_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Replace Image",
      validation: { required: "Image URL is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  airlinesPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  cargo: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_agency_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_agency_order_sequence",
        formType: "number",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_agency_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_agency_title_zh",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_zh",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Link (EN)",
      fieldValue: "field_agency_link_en",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_en",
      formType: "input",
      label: "Link (EN)",
      placeholder: "Enter Link (EN)",
      validation: { required: "Link (EN) is required" },
    },
    {
      fieldName: "Link (MS)",
      fieldValue: "field_agency_link_ms",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_ms",
      formType: "input",
      label: "Link (MS)",
      placeholder: "Enter Link (MS)",
      // validation: { required: "Link (MS) is required" },
    },
    {
      fieldName: "Link (ZH)",
      fieldValue: "field_agency_link_zh",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_zh",
      formType: "input",
      label: "Link (ZH)",
      placeholder: "Enter Link (ZH)",
      // validation: { required: "Link (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_agency_image",
      className: "col-span-6",
      type: "image",
      name: "field_agency_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Replace Image",
      validation: { required: "Image URL is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  cargoPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  groundHandlers: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_agency_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_agency_order_sequence",
        formType: "number",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_agency_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_agency_title_zh",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_zh",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Link (EN)",
      fieldValue: "field_agency_link_en",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_en",
      formType: "input",
      label: "Link (EN)",
      placeholder: "Enter Link (EN)",
      validation: { required: "Link (EN) is required" },
    },
    {
      fieldName: "Link (MS)",
      fieldValue: "field_agency_link_ms",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_ms",
      formType: "input",
      label: "Link (MS)",
      placeholder: "Enter Link (MS)",
      // validation: { required: "Link (MS) is required" },
    },
    {
      fieldName: "Link (ZH)",
      fieldValue: "field_agency_link_zh",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_zh",
      formType: "input",
      label: "Link (ZH)",
      placeholder: "Enter Link (ZH)",
      // validation: { required: "Link (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_agency_image",
      className: "col-span-6",
      type: "image",
      name: "field_agency_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Replace Image",
      validation: { required: "Image URL is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  groundHandlersPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  groundHandlersNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: {
        required: "Content for Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
  ],
  cargoNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: {
        required: "Content for Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
  ],
  airlinesNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: {
        required: "Content for Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
  ],
  agenciesNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: {
        required: "Content for Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
  ],
};
